/* eslint-disable react/no-unknown-property */
/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import PropTypes from 'prop-types';

import ExpandableContent from 'Component/ExpandableContent';
import ProductAttributeValue from 'Component/ProductAttributeValue';
import ProductConfigurableAttributes
from 'Component/ProductConfigurableAttributes/ProductConfigurableAttributes.component';
import TextPlaceholder from 'Component/TextPlaceholder';

import './ProductColorAttribute.style';

/** @namespace Scandipwa/Component/ProductColorAttribute/Component */
export class ProductColorAttributeComponent extends ProductConfigurableAttributes {
    static propTypes = {
        ...super.propTypes,
        use_thumbnail_as_swatch: PropTypes.bool.isRequired
    };

    renderConfigurableAttributeValue(attribute) {
        const {
            getIsConfigurableAttributeAvailable,
            handleOptionClick,
            getLink,
            isSelected,
            product,
            parameters
        } = this.props;

        const { attribute_value } = attribute;

        return (
            <ProductAttributeValue
              isReplace
              key={ attribute_value }
              attribute={ attribute }
              isSelected={ isSelected(attribute) }
              isAvailable={ getIsConfigurableAttributeAvailable(attribute) }
              onClick={ handleOptionClick }
              getLink={ getLink }
              product={ product }
              parameters={ parameters }
            />
        );
    }

    renderSwatch(option) {
        const {
            attributeValidation: { isColorValid },
            getSubHeading,
            use_thumbnail_as_swatch
        } = this.props;
        const { attribute_values } = option;

        return (
            <>
                <div
                  block="ProductConfigurableAttributes"
                  elem="SwatchList"
                  mods={ { isInvalid: !isColorValid, isThumbnail: use_thumbnail_as_swatch } }
                >
                    { attribute_values.map((attribute_value) => (
                        this.renderConfigurableAttributeValue({ ...option, attribute_value })
                    )) }
                </div>
                <div
                  block="ProductConfigurableAttributes"
                  elem="ColorSubLabel"
                >
                    <div
                      block="ProductConfigurableAttributes"
                      elem="ColorSubLabelKey"
                    >
                        { __('Color:') }
                    </div>
                    <div
                      block="ProductConfigurableAttributes"
                      elem="ColorSubLabelValue"
                    >
                        { getSubHeading(option) }
                    </div>
                </div>
            </>
        );
    }

    renderPlaceholders() {
        const { numberOfPlaceholders, isContentExpanded } = this.props;

        return (
            <>
                { numberOfPlaceholders.map((length, i) => (
                    <ExpandableContent
                        // eslint-disable-next-line react/no-array-index-key
                      key={ i }
                      mix={ {
                          block: 'ProductConfigurableAttributes',
                          elem: 'Expandable'
                      } }
                      isContentExpanded={ isContentExpanded }
                    >
                        <div
                            // eslint-disable-next-line react/no-array-index-key
                          key={ i }
                          block="ProductConfigurableAttributes"
                          elem="SwatchList"
                        >
                            { Array.from({ length }, (_, i) => (
                                <div
                                  // eslint-disable-next-line react/no-array-index-key
                                  key={ i }
                                  block="ProductConfigurableAttributes"
                                  elem="Placeholder"
                                />
                            )) }
                        </div>
                    </ExpandableContent>
                )) }
                <span
                  block="ProductConfigurableAttributes"
                  elem="ColorText"
                >
                    <TextPlaceholder
                      content={ false }
                      mix={ { block: 'ProductConfigurableAttributes', elem: 'ColorLabelPlaceholder' } }
                      length="short"
                    />
                    <TextPlaceholder
                      content={ false }
                      mix={ { block: 'ProductConfigurableAttributes', elem: 'ColorTextPlaceholder' } }
                      length="short"
                    />
                </span>
            </>
        );
    }
}

export default ProductColorAttributeComponent;
